import React, {ReactNode} from 'react'
import useLanguage from 'features/languageReport/useLanguage'
import EEGSummaryBrain3DAPI from 'components/molcules/N1SummaryReport/EEG/EEGSummaryBrain3dAPI'
import EEGSummaryOpinionAPI from 'components/molcules/N1SummaryReport/EEG/EEGSummaryOpnionAPI'
import useStyles from 'components/molcules/N1SummaryReport/useStyles'

interface EEGSummaryProps {
  contourImage?: string
  threeDimensionImage: string
  total: number
  CustomerCard?: ReactNode
  isSummary?: boolean
}

export default function EEGSummaryAPI(props: EEGSummaryProps) {
  const {contourImage, threeDimensionImage, total, CustomerCard, isSummary} =
    props
  const classes = useStyles()
  const {textEegAPI} = useLanguage('eeg')

  return (
    <div className={classes.root}>
      {CustomerCard && CustomerCard}
      <EEGSummaryBrain3DAPI
        index={1}
        threeDimensionImage={threeDimensionImage}
        isSummary={isSummary}
      />
      <EEGSummaryOpinionAPI
        index={2}
        score={total}
        contourImage={contourImage}
        isSummary={isSummary}
      />
      <div className='Warning'>{`${textEegAPI?.footer[0]} ${textEegAPI?.footer[1]}`}</div>
    </div>
  )
}
